module.exports = __webpack_public_path__ + "img/page9img1.8b5f90cb.png";